import StandardGateway from './lib/standard_gateway';

export default class EndpointsGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/configuration/endpoints/:id');
  }

  replace(params, data) {
    if (Array.isArray(data)) {
      const promises = data.map(item => {
        const url = this.endpoint.set({ id: item.id }).replaceUrl;
        return this.http.put(url, item);
      });

      return Promise.all(promises)
        .then(dto => this.observer.onReplaceSuccess(dto, params))
        .catch(error => this.observer.onReplaceError(error, params));
    } else {
      return super.replace(params, data);
    }
  }
}
